//#region Imports
import React, { useState, useEffect, useRef } from 'react';
import { View, StyleSheet, SafeAreaView, Image, TouchableOpacity, Dimensions, Platform, Pressable, FlatList, useWindowDimensions, ActivityIndicator } from 'react-native';
import { Card, Provider } from 'react-native-paper';
import { showMessage } from "react-native-flash-message";
import { useAuthContext } from '../../../hooks/useAuthContext';
import { useAccountContext } from '../../../hooks/useAccountContext';
import { useTheme, useNavigation } from '@react-navigation/native';
import { useSignin } from '../../../hooks/useSignIn';
import CustomButton from '../../../components/CustomButton';
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import CustomInput from '../../../components/CustomInput';
import TeamsLeaveSchedulerScreen from '../Team/TeamsLeaveSchedulerScreen';
import { changeDateFromMMMDDYYYYToYYYYMMDD } from '../../../constants/FormatDate';
import { useAccount } from '../../../hooks/useAccount';
import axios from 'axios';
import Modal from "react-native-modal";
import { useTranslation } from 'react-i18next';
import ReactNativeBlobUtil from 'react-native-blob-util';
import { useLeave } from '../../../hooks/useLeave';
import moment from 'moment';
import { createCommonStyles } from '../../../styles/commonStyles';
import { useSettingsContext } from '../../../hooks/useSettingsContext';
import { useSafeAreaInsets } from "react-native-safe-area-context";
const androidUtil = ReactNativeBlobUtil.android
const iosUtil = ReactNativeBlobUtil.ios
//#endregion

const LeaveApplicationApprovalScreen = (props) => {
    //#region Dimensions
    const { width, height } = useWindowDimensions();
    const rejectionCommentsModalHeight = height * 30 / 100;
    //#endregion

    //#region Functions definitions, variables and states
    const { colors } = useTheme();
    const navigation = useNavigation();
    const styles = makeStyles(colors, height, width, rejectionCommentsModalHeight);
    const common = createCommonStyles(colors);
    const { t, i18n } = useTranslation();
    const { username, user, clientApi } = useAuthContext();
    const { GetLeaves } = useLeave()
    const { addApproverComments } = useSettingsContext();
    const { refreshSignIn } = useSignin();
    const { oasisParam, account } = useAccountContext();
    const { pendingActivitiesCountGet } = useAccount();
    const [data, setdata] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [Comments, setComments] = useState("");
    const [selectedStartDate, setSelectedStartDate] = useState("");
    const [laaForceRefresh, setLaaForceRefresh] = useState(false);
    const insets = useSafeAreaInsets();
    //#endregion

    //#region Navigation
    useEffect(() => {
        navigation.setOptions({
            title: t('navigate:LAA')
        });
    }, []);

    //#endregion

    //#region Helper
    const CreateDivider = () => {
        return (
            <View
                style={{
                    borderBottomColor: colors.text_primary,
                    marginVertical: 10,
                    borderBottomWidth: StyleSheet.hairlineWidth,
                }}
            />
        );
    };
    //#endregion

    //#region Listeners
    const openAttachment = async (item) => {
        if (Platform.OS === 'web') {
            // create blob
            const blobData = await fetch(`data:plain/text;base64,${item.data}`).then(res => {
                return res.blob();
            });

            // create download link
            const url = URL.createObjectURL(blobData);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
                'download',
                `${item.name}.${item.type}`,
            );

            // insert link on page
            document.body.appendChild(link);

            // start download
            link.click();

            // remove link
            link.parentNode.removeChild(link);
        } else {
            // for ios, use documents directory
            // for android, use downloads directory
            // note: documents directory can be used for both android and ios
            const dirPath =
                Platform.OS === 'ios'
                    ? `${ReactNativeBlobUtil.fs.dirs.DocumentDir}`
                    : `${ReactNativeBlobUtil.fs.dirs.DownloadDir}`;

            const filePath = dirPath + `/${item.name}.${item.type}`;

            // create file
            ReactNativeBlobUtil.fs.writeFile(filePath, item.data, 'base64')
                .then((success) => {
                    // console.log('FILE WRITTEN!');
                })
                .catch((err) => {
                    console.log(err.message);
                });

            // open file
            if (Platform.OS === 'ios') {
                iosUtil.openDocument(filePath);
            } else {
                androidUtil.actionViewIntent(filePath, mime.lookup(item.type));
            };
        };
    };

    //* Show/Hide extra details for leave. Main details are leave type, dates
    const ShowHideMenu = (item) => {
        const [showDetails, setShowDetails] = React.useState(false);
        const [isModalOpen, setIsModalOpen] = React.useState(false);
        const [typeOfApproval, setTypeOfApproval] = useState('');
        const [lines, setLines] = useState([]);
        let period = `${item.startdate} - ${item.enddate}`

        useEffect(() => {
            // console.log(isModalOpen)
        }, [isModalOpen])

        if (item?.leavelines !== undefined) {
            var leavelines = JSON.parse(item?.leavelines);
            useEffect(() => {
                setLines(leavelines.map(line => ({
                    ...line,
                    duration: line.duration,
                    totalduration: line.totalduration
                })));
            }, []);
        }
        const onShowHidePress = (item) => {
            setShowDetails(!showDetails)
        }

        return (
            // * FlatList Main Data
            <View style={styles.showHide}>
                <Pressable onPress={() => {
                    onShowHidePress(item)
                }}>
                    {Platform.OS === 'web' && width > 1200 ?
                        <SafeAreaView>
                            <View
                                style={styles.row}>
                                <CustomLabel
                                    value={item.acodeDesc}
                                    type='AVAILABLEUSED' />
                                <CustomLabel
                                    value={item.startdate}
                                    type='AVAILABLEUSED_SECONDARY' />
                                <CustomLabel
                                    value={item.enddate}
                                    type='AVAILABLEUSED_SECONDARY' />
                                <CustomLabel
                                    value={item.name}
                                    type='AVAILABLEUSED_SECONDARY' />
                            </View>
                            {showDetails && CreateDivider()}
                        </SafeAreaView>
                        :
                        <View
                            style={styles.row}>
                            <View
                                style={[
                                    styles.leaveState,
                                    { backgroundColor: item.acodeColour },
                                ]} />
                            <View>
                                <CustomLabel
                                    value={item.name}
                                    type='AVAILABLEUSED' />
                                <CustomLabel
                                    value={period}
                                    type='AVAILABLEUSED_SMALL' />
                                <CustomLabel
                                    value={item.acodeDesc}
                                    type='AVAILABLEUSED_SMALL' />
                            </View>
                        </View>
                    }
                </Pressable>

                {showDetails == true &&
                    <SafeAreaView
                        style={styles.details}>
                        <SafeAreaView style={styles.item}>
                            <View style={styles.lineInvisible} />
                            <View
                                style={styles.row}>
                                <CustomLabel
                                    value={t('common:LT') + `:`}
                                    type='LEAVEDETAILSMAJOR' />
                                <CustomLabel
                                    value={item.acodeDesc}
                                    type='AVAILABLEUSED_SECONDARY' />
                            </View>
                            <View style={styles.line} />
                        </SafeAreaView>
                        <SafeAreaView style={styles.item}>
                            <View
                                style={styles.row}>
                                <CustomLabel
                                    value={t('common:LD') + `:`}
                                    type='LEAVEDETAILSMAJOR' />
                                <CustomLabel
                                    value={item.startdate + ` - ` + item.enddate}
                                    type='AVAILABLEUSED_MUTED' />
                            </View>
                            <View style={styles.line} />
                        </SafeAreaView>
                        <SafeAreaView style={styles.item}>
                            <View
                                style={styles.row}>
                                <CustomLabel
                                    value={t('common:Dur') + `:`}
                                    type='LEAVEDETAILSMAJOR' />
                                <CustomLabel
                                    value={item.duration + " " + t('common:leaveUnit', { leaveUnit: i18n.language === "gr" ? oasisParam.leaveUnit === "H" ? "ώρες" : "ημέρες" : oasisParam.leaveUnit === "H" ? "hours" : "days" })}
                                    type='AVAILABLEUSED_SECONDARY' />
                            </View>
                            <View style={styles.line} />
                        </SafeAreaView>
                        <SafeAreaView style={styles.item}>
                            <View
                                style={styles.row}>
                                <CustomLabel
                                    value={t('common:Comm') + `:`}
                                    type='LEAVEDETAILSMAJOR' />
                                <CustomLabel
                                    value={item.comments}
                                    type='AVAILABLEUSED_MUTED' />
                            </View>
                            <View style={styles.line} />
                        </SafeAreaView>
                        {lines.length > 0 &&
                            <SafeAreaView style={styles.black}>
                                <CustomLabel
                                    value={t('common:LL') + `:`}
                                    type='LEAVEDETAILSMAJOR' />
                                <SafeAreaView>
                                    {lines.map((item, index) => {
                                        return (
                                            <View style={styles.row}
                                                key={index}>
                                                <CustomLabel
                                                    value={moment(item.linedate).format("MMM DD YYYY") + ' - ' + item.nameofday}
                                                    type='AVAILABLEUSED_SECONDARY' />
                                                <CustomLabel
                                                    value={item.duration + ' ' + t('common:leaveUnit', { leaveUnit: i18n.language === "gr" ? oasisParam.leaveUnit === "H" ? "ώρες" : "ημέρες" : oasisParam.leaveUnit === "H" ? "hours" : "days" })}
                                                    type='AVAILABLEUSED_MUTED' />
                                            </View>
                                        )
                                    })
                                    }
                                </SafeAreaView>
                                <View style={styles.line} />
                            </SafeAreaView>}

                        <SafeAreaView style={styles.item}>
                            <View
                                style={styles.row}>
                                <CustomLabel
                                    value={t('common:currentRemainder') + `:`}
                                    type='LEAVEDETAILSMAJOR' />
                                <CustomLabel
                                    value={item.remaining + " " + t('common:leaveUnit', { leaveUnit: i18n.language === "gr" ? oasisParam.leaveUnit === "H" ? "ώρες" : "ημέρες" : oasisParam.leaveUnit === "H" ? "hours" : "days" })}
                                    type='AVAILABLEUSED' />
                            </View>
                            <View style={styles.line} />
                        </SafeAreaView>
                        {/* show attachments */}
                        {item.attachments.length > 0 && <View >
                            <CustomLabel
                                value={t('common:lAttach') + `:`}
                                type='LEAVEDETAILSMAJOR' />

                            {item.attachments.map((attachment) => {
                                return (
                                    <TouchableOpacity key={attachment.name + '.' + attachment.type} onPress={() => openAttachment(attachment)}>
                                        <CustomLabel
                                            value={attachment.name + '.' + attachment.type.toLowerCase()}
                                            type='LEAVEDETAILSMINORLINK' />
                                    </TouchableOpacity>
                                )
                            })}
                        </View>}
                        {item.teamOnLeave.length !== 0 &&
                            <View style={styles.teamMember}>
                                <View style={styles.row}>
                                    <CustomLabel
                                        value={t('common:TeamMembersOnLeave')}
                                        type='AVAILABLEUSED_SECONDARY' />
                                    {Platform.OS !== 'web' && <CustomButton
                                        type='MONTHLYLEAVESCHEDULE'
                                        show='MONTHLYLEAVESCHEDULE'
                                        textTop='0'
                                        sz={20}
                                        onPress={() => {
                                            props.selectTeamsLeaveSchedulerScreen(changeDateFromMMMDDYYYYToYYYYMMDD(item.startdate))
                                        }}
                                        iconName='today-outline' />
                                    }
                                </View>
                                {item.teamOnLeave.map((teamMember, index) => {
                                    return (
                                        <View
                                            key={index}
                                            style={styles.TeamMemberRow}>
                                            <CustomLabel
                                                value={teamMember.teammateName}
                                                type='AVAILABLEUSED_SECONDARY' />
                                            <CustomLabel
                                                value={`${teamMember.startDate} - ${teamMember.endDate}`}
                                                type='AVAILABLEUSED_SECONDARY' />
                                        </View>
                                    )
                                })}
                            </View>
                        }
                        <SafeAreaView style={styles.marginContainer}>
                            <AcceptRejectButtons
                                item={item}
                                setIsModalOpen={setIsModalOpen}
                                setTypeOfApproval={setTypeOfApproval} />
                        </SafeAreaView>
                    </SafeAreaView>
                }
                <Modal
                    isVisible={isModalOpen}
                    backdropColor={colors.background_approved}
                    backdropOpacity={0.9}
                    onBackdropPress={() => setIsModalOpen(false)}
                    onRequestClose={() => setIsModalOpen(false)}>
                    <SafeAreaView
                        style={styles.container}>
                        <StatefulModalContent
                            item={item}
                            typeOfApproval={typeOfApproval}
                            setIsModalOpen={setIsModalOpen} />
                    </SafeAreaView>
                </Modal>
            </View>
        );
    };

    const AcceptLeave = ({ item, comments, setIsModalOpen }) => {
        setIsModalOpen(false);
        const leaveData = { LeaveId: item.leaveId, Username: username, Comments: comments };
        const apiRoute = 'api/LAA/LeaveApprove';
        postToAPi(leaveData, apiRoute, 'AcceptedLeave');
    };

    //! not used currently
    const RejectLeave = ({ item, comments, setIsModalOpen }) => {
        setIsModalOpen(false);
        const leaveData = { LeaveId: item.leaveId, Username: username, Comments: comments };
        const apiRoute = 'api/LAA/LeaveReject';
        postToAPi(leaveData, apiRoute, 'RejectLeave');
    };

    const UnsubmitLeave = ({ item, comments, setIsModalOpen }) => {
        setIsModalOpen(false);
        const leaveData = { LeaveId: item.leaveId, Username: username, Comments: comments };
        const apiRoute = 'api/LAA/LeaveUnsubmit';
        postToAPi(leaveData, apiRoute, 'RejectLeave');
    };

    const clickedItem = (data) => {
        setSelectedStartDate(changeDateFromMMMDDYYYYToYYYYMMDD(data.startdate))
        // console.log("TODO Listener for clicking the whole card, Maybe for adding extra INFO ... ALSO ADD ATTACHMENTS");
    };

    // * Refresh count after approving a leave
    const onPendingActivitiesCountGet = async () => {
        setComments("");
        await pendingActivitiesCountGet()
    }
    //#endregion

    //#region API functions
    // * Post to api Approve, Reject 
    const postToAPi = (leaveData, apiRoute, action) => {
        setLoading(true)
        axios.post(`${clientApi}${apiRoute}`, leaveData, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + user.token
            },
        })
            .then((response) => {
                // * Refresh data on success 
                GetData()
                // * Show success message 
                let msg = '';
                if (action === 'AcceptedLeave')
                    msg = t('common:leaveApprovalAccepted');
                else if (action === 'RejectLeave')
                    msg = t('common:leaveApprovalRejected');
                else
                    msg = t('common:leaveApprovalUnsubmitted');

                showMessage({
                    message: msg,
                    type: "success",
                    duration: 3000,
                });
                setLoading(false)
                // * Refresh count on success 
                onPendingActivitiesCountGet().catch(console.error);
                GetLeaves().catch(console.error);
                setLaaForceRefresh(true);
            })
            .catch((error) => {
                console.log(error.message)
                setLoading(false);
                if (action === 'AcceptedLeave')
                    msg = t('common:leaveApprovalAcceptedFailed');
                else if (action === 'RejectLeave')
                    msg = t('common:leaveApprovalRejectedFailed');
                else
                    msg = t('common:leaveApprovalUnsubmittedFailed');
                showMessage({
                    message: msg,
                    type: "danger",
                    duration: 3000,
                });
            })
    }

    // * This is called from the useeffect and also from on refresh 
    const GetData = async () => {
        setLoading(true)

        await axios.get(`${clientApi}api/Employee/LAAPending`, {
            headers: { Authorization: `Bearer ${user.token}` },
            params: {
                username: username
            }
        })
            .then(async (response) => {
                try {
                    setdata(response.data);
                } catch (error) {
                    setdata([]);
                }
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    refreshSignIn(user, clientapi)
                }
                console.error(error.message)
            })
        setLoading(false)
    }
    //#endregion

    //#region function UseEffects
    useEffect(() => {
        const onLAAGet = async () => {
            await GetData()
        };
        onLAAGet()
            .catch(console.error);
    }, []);

    useEffect(
        () => {
            // * No need to do anything here
        },
        [width, height]
    );
    //TODO Search Functionality 
    useEffect(() => {
    }, [search]);
    //#endregion

    //#region Reused code abstraction
    const StatefulModalContent = ({ item, setIsModalOpen, typeOfApproval }) => {
        const [comments, setComments] = useState();
        const isReject = typeOfApproval === 'reject';
        const isUnsub = typeOfApproval === 'unsubmit';
        return (
            <View style={styles.modalContent}>
                <CustomInput
                    type='LAA_Comments'
                    multiline={true}
                    numberOfLines={Platform.OS === 'android' ? 3 : null}
                    placeholder='Comments (Optional)'
                    value={comments}
                    setValue={setComments}
                />
                <View
                    style={styles.modalButtonsRow}>
                    {!isUnsub ? <CustomButton
                        text={isReject ? t('common:reject') : t('common:approve')}
                        onPress={() => { isReject ? RejectLeave({ item, comments, setIsModalOpen }) : AcceptLeave({ item, comments, setIsModalOpen }) }}
                        type={isReject ? "REJECT" : "APPROVE"}
                        iconName="close-outline"
                        sz={20}
                        show="HIDE"
                        isGradient={isReject ? false : true}
                    /> :
                        <CustomButton
                            text={t('common:unsubmit')}
                            onPress={() => { UnsubmitLeave({ item, comments, setIsModalOpen }) }}
                            type={"REJECT"}
                            iconName="close-outline"
                            sz={20}
                            show="HIDE"
                        />}
                    <View style={styles.spacer}></View>
                    <CustomButton
                        onPress={() => setIsModalOpen(false)}
                        type={isReject ? "REJECT" : "APPROVE"}
                        fgColor="#1C5103"
                        text={t('common:cancel')}
                        iconName="checkmark-outline"
                        sz={20}
                        show="HIDE"
                    />
                </View>
            </View>
        );
    };

    const AcceptRejectButtons = ({ item, setIsModalOpen, setTypeOfApproval }) => {
        return (
            <View
                style={{
                    flex: 1,
                    flexDirection: 'row',
                    justifyContent: "center",
                    alignContent: 'center'
                }}>

                {item.isRejected ? <CustomButton
                    text={t('common:unsubmit')}
                    onPress={() => { setIsModalOpen(true); setTypeOfApproval('unsubmit'); }}
                    type="REJECT"
                    iconName="close-outline"
                    sz={20}
                    show="HIDE"
                />
                    : <CustomButton
                        text={t('common:reject')}
                        onPress={() => { setIsModalOpen(true); setTypeOfApproval('reject'); }}
                        type="REJECT"
                        iconName="close-outline"
                        sz={20}
                        show="HIDE"
                    />}

                <View style={styles.spacer}></View>
                <CustomButton
                    onPress={() => {
                        if (addApproverComments) {
                            setIsModalOpen(true);
                            setTypeOfApproval('approve');
                        } else {
                            AcceptLeave({ item, comments: '', setIsModalOpen });
                        }
                    }}
                    type="APPROVE"
                    text={t('common:approve')}
                    iconName="checkmark-outline"
                    sz={20}
                    show="HIDE"
                    isGradient={true}
                />
            </View>
        )
    }
    // #endregion

    //#region Render Functions
    //* Rendering data of flat list into a card with two text rows 
    //* Approver see both Rejected and Submitted Leaves, Rejected are red ouline, and green outline for submitted
    //* Approver can either unsubmit or approve rejected leaves
    const renderData = (item) => {
        return (
            <Provider>
                {Platform.OS !== 'web' ?
                    <Card
                        style={selectedStartDate === changeDateFromMMMDDYYYYToYYYYMMDD(item.item.startdate) ? styles.cardstyleOpen : [common.cardstyle, { borderColor: item.item.isRejected ? colors.background_rejected : colors.border_card }]}>
                        <Card.Content>
                            <ShowHideMenu {...item.item} />
                        </Card.Content>
                    </Card>
                    :
                    <Card
                        style={selectedStartDate === changeDateFromMMMDDYYYYToYYYYMMDD(item.item.startdate) ? styles.cardstyleOpen : [common.cardstyle, { borderColor: item.item.isRejected ? colors.background_rejected : colors.border_card, borderWidth: 5 }]}>
                        <Card.Content>
                            <ShowHideMenu {...item.item} />
                        </Card.Content>
                    </Card>
                }
            </Provider >
        )
    }
    //#endregion
    if (props.isDashboard)
        return (
            <SafeAreaView style={styles.mainDashboard}>
                <View style={styles.circle}>
                    <CustomLabel
                        value={data.length}
                        type='DASHBOARD'
                    />
                </View>
            </SafeAreaView >
        );

    return (
        <SafeAreaView style={[styles.main, { paddingBottom: Math.max(insets.bottom + 24, 40) }]}>
            <CustomLabel
                value={t('navigate:LAA')}
                type='MINORTITLE'
            />
            <SafeAreaView style={styles.rowView}>
                {(Platform.OS === 'web' && width > 1200) &&
                    <SafeAreaView style={[common.cardstyle, styles.calendarCardStyle]}>
                        <TeamsLeaveSchedulerScreen
                            LAA={true}
                            date={selectedStartDate}
                            setSelectedStartDate={setSelectedStartDate}
                            laaForceRefresh={laaForceRefresh}
                            setLaaForceRefresh={setLaaForceRefresh} />
                    </SafeAreaView>
                }
                <SafeAreaView style={styles.subMain}>
                    {loading ?
                        <CustomLabel
                            value={t('common:LoadingLeaves')}
                            type='MINORTITLE'
                        /> :
                        data.length === 0 || data === undefined ?
                            <CustomLabel
                                value={t('common:NOLAA')}
                                type='MINORTITLE'
                            /> :
                            <FlatList
                                data={data}
                                renderItem={renderData}
                                removeClippedSubviews={false}
                                onRefresh={() => GetData()}
                                scrollEnabled={true}
                                refreshing={loading}
                                keyExtractor={(item, index) => item + index}
                                initialNumToRender={4}
                            />
                    }

                </SafeAreaView>
            </SafeAreaView>
        </SafeAreaView>
    )
}

const makeStyles = (colors, height, width, rejectionCommentsModalHeight) => StyleSheet.create({
    main: {
        flex: 1,
        marginRight: '2%',
        marginLeft: '2%',
    },
    mainDashboard: {
        flex: 1,
        marginRight: '2%',
        alignItems: 'center',
        marginLeft: '2%',
    },
    details: {
        flex: 1,
        margin: '2%',
    },
    subMain: {
        flex: 1,
        marginTop: 10,
    },
    rowView: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center',
    },
    leaveState: {
        width: 35,
        borderRadius: 5,
        marginRight: (Platform.OS === 'web' && width > 1200 ? 0 : '2%'),
        height: 35,
    },
    container: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    spacer: {
        margin: '2%'
    },
    calendarCardStyle: {
        flex: 1,
        marginHorizontal: 15,
    },
    cardstyleOpen: {
        marginLeft: (Platform.OS === 'web' && width > 1200 ? '2%' : '4%'),
        marginRight: (Platform.OS === 'web' && width > 1200 ? '2%' : '4%'),
        marginTop: 10,
        marginBottom: 10,
        borderRadius: 5,
        borderWidth: 1,
        borderColor: colors.buttons_primary,
        elevation: 3,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.1,
        shadowRadius: 5,
        backgroundColor: colors.background_card,
    },

    title: {
        fontSize: 20,
        color: colors.text_primary,
        fontFamily: 'Roboto-Medium',
    },
    showHide: {
        backgroundColor: colors.background_card,
    },
    line: {
        borderBottomColor: colors.text_primary,
        borderBottomWidth: StyleSheet.hairlineWidth,
        marginTop: (Platform.OS === 'web' && width > 1200) ? 10 : 20,
        marginBottom: (Platform.OS === 'web' && width > 1200) ? 10 : 20,
    },
    lineInvisible: {
        borderBottomColor: 'transparent',
        borderBottomWidth: StyleSheet.hairlineWidth,
        marginTop: (Platform.OS === 'web' && width > 1200) ? 0 : 20,
        marginBottom: (Platform.OS === 'web' && width > 1200) ? 0 : 20,
    },
    teamMember: {
        flex: 1,
        marginTop: 10,
        marginBottom: 20,
    },
    TeamMemberRow: {
        flexDirection: 'row',
        justifyContent: 'center',
        marginLeft: "5%",
        marginRight: "5%",
    },
    row: {
        flex: 1,
        marginVertical: 10,
        flexDirection: "row",
    },
    item: {
        flex: 1,
        padding: 10,
    },
    marginContainer: {

    },
    modalContent: {
        width: (Platform.OS === 'web' && width > 1200 ? '40%' : '100%'),
        height: rejectionCommentsModalHeight,
        justifyContent: 'center',
        backgroundColor: colors.background_card,
        borderRadius: 20,
        borderWidth: 3,
        borderColor: '#a1a1a1',
        padding: 10,
    },
    modalButtonsRow: {
        flexDirection: 'row',
        justifyContent: 'center',
        marginTop: 10,
        flex: 1,
    },
    loading: {
        flex: 1,
        marginTop: "1%",
        marginLeft: "2%",
        marginRight: "2%",
    },

    // DASHBOARD CIRCLE
    circle: {
        width: 80,               // larger circle
        height: 80,
        borderRadius: 40,        // half of width/height for a perfect circle
        borderWidth: 4,          // thickness of the blue border
        borderColor: colors.buttons_primary,
        backgroundColor: 'white',// white center
        justifyContent: 'center',
        alignItems: 'center',
        margin: 10,
    },
    numberText: {
        color: 'white',
        fontSize: 20,
        fontWeight: 'bold',
    },
});

export default LeaveApplicationApprovalScreen;